<template>
  <div class="correct-header section_">
    <div v-if="!isMobile">
      <p class="productName">{{ policy.productName }}</p>
      <a-form-model-item class="flex_ date-range" label="保险起止日期">
        <a-date-picker v-model="policy.effectiveDate" placeholder="开始日期" disabled />
        至
        <a-date-picker v-model="policy.expireDate" placeholder="结束日期" disabled />
      </a-form-model-item>
    </div>
    <div v-else>
      <correct-title title="保险日期" />
      <a-row class="mobile-date-row" type="flex" align="middle">
        <a-col :xs="10" :sm="8" :md="6" class="mobile-col">
          <label class="mobile-label">投保开始日期</label>
        </a-col>
        <a-col :xs="14" :sm="16" :md="18">
          <a-date-picker class="mobile-form-control" v-model="policy.effectiveDate" placeholder="开始日期" disabled />
        </a-col>
      </a-row>
      <a-row class="mobile-date-row" type="flex" align="middle">
        <a-col :xs="10" :sm="8" :md="6" class="mobile-col no-border">
          <label class="mobile-label">投保结束日期</label>
        </a-col>
        <a-col :xs="14" :sm="16" :md="18">
          <a-date-picker class="mobile-form-control" v-model="policy.expireDate" placeholder="结束日期" disabled />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import correctTitle from './title';
export default {
  name: 'correctHeader',
  components: {
    correctTitle
  },
  inject: ['isMobile'],
  props: {
    policy: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.correct-header {
  .productName {
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-size: 14px;
    font-weight: bold;
    color: #121212;
    line-height: 21px;
  }
  .date-range {
    margin-bottom: 0;
  }
}
.mobile_ {
  .mobile-date-row {
    height: 50px;
    border-bottom: 1px solid #f3f3f3;
  }
  .mobile-col {
  }
}
</style>
